// /client/src/composables/useParticlePhysics.js
import * as THREE from 'three'

const PARTICLE_COUNT = 2000
const RADIUS = 50

export function applyDirectionalForce(positions, velocities, origin, direction, strength = 1, radius = 20) {
  const dir = direction.clone().normalize()

    for (let i = 0; i < positions.length; i += 3) {
      
    const particlePos = new THREE.Vector3(positions[i], positions[i + 1], positions[i + 2])
    const toParticle = particlePos.clone().sub(origin)
    const distance = toParticle.length()
        if (i === 0) {
 // console.log("🧪 dist to origin:", distance)
}

    if (distance < radius) {
      const influence = 1 - (distance / radius)
      velocities[i]     += dir.x * strength * influence
      velocities[i + 1] += dir.y * strength * influence
      velocities[i + 2] += dir.z * strength * influence
    }
  }
}

export function createParticles() {
  const geometry = new THREE.BufferGeometry()
  const positions = new Float32Array(PARTICLE_COUNT * 3)
  const velocities = new Float32Array(PARTICLE_COUNT * 3)

  for (let i = 0; i < PARTICLE_COUNT; i++) {
    const theta = Math.random() * 2 * Math.PI
    const phi = Math.acos(2 * Math.random() - 1)

    const x = RADIUS * Math.sin(phi) * Math.cos(theta)
    const y = RADIUS * Math.sin(phi) * Math.sin(theta)
    const z = RADIUS * Math.cos(phi)

    positions.set([x, y, z], i * 3)
    velocities.set([0, 0, 0], i * 3)
  }

  geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

  return { geometry, positions, velocities }
}

export function updateParticles(positions, velocities, damping = 0.99, delta = 0.016) {
    for (let i = 0; i < positions.length; i += 3) {
       // if (velocities[i] !== 0 || velocities[i + 1] !== 0 || velocities[i + 2] !== 0) {
      //  console.log("🎯 updating particle", i / 3)
        //}
    positions[i] += velocities[i] * delta
    positions[i + 1] += velocities[i + 1] * delta
    positions[i + 2] += velocities[i + 2] * delta

    velocities[i] *= damping
    velocities[i + 1] *= damping
    velocities[i + 2] *= damping
  }
}

export function initScene(container) {
  //if (!container) throw new Error("Container DOM element not ready.")
  const scene = new THREE.Scene()

  const camera = new THREE.PerspectiveCamera(
    75,
    container.clientWidth / container.clientHeight,
    0.1,
    1000
  )
  camera.position.z = 150

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
  renderer.setSize(container.clientWidth, container.clientHeight)
  container.appendChild(renderer.domElement)

  return { scene, camera, renderer }
}
